import * as z from 'zod';

import { isEmpty } from '@hsp/utilities';

import { AudienceOrderType } from 'types/api';
import { s } from 'utilities/strings';

export const ProcessFormSchema = z
  .object({
    deduplicate: z.boolean(),
    fileName: z.string().optional(),
    includeHpcMrc: z.boolean(),
    list: z.string().optional(),
    mailer: z.string().optional(),
    nth: z
      .number()
      .min(1, { message: s(['Site.Pages.AudienceBuilder.Dashboard.Messages.Process.Validation.Nth']) })
      .optional(),
    orderNumber: z.string().optional(),
    orderType: z.nativeEnum(AudienceOrderType).optional(),
    sendToRp: z.boolean().optional(),
    subject: z.string().optional(),
    to: z.preprocess(
      (arg) => (isEmpty(arg) ? undefined : arg),
      z
        .string()
        .email({ message: s(['Site.Pages.AudienceBuilder.Dashboard.Messages.Process.Validation.Email']) })
        .array()
        .optional()
    ),
  })
  .superRefine(({ fileName, sendToRp }, context) => {
    if (sendToRp && isEmpty(fileName)) {
      context.addIssue({
        code: z.ZodIssueCode.custom,
        fatal: true,
        message: s(['Site.Pages.AudienceBuilder.Dashboard.Messages.Process.RedPointFileName']),
        path: ['fileName'],
      });

      return false;
    }

    return true;
  });

export type ProcessForm = z.infer<typeof ProcessFormSchema>;
export type ProcessFormTo = ProcessForm['to'];
